// Claude: extracted from RFXDetail — all seller-side modals in one place 18-04-2026
import React from "react";
import { Box, Flex, Text, Button, Input } from "@chakra-ui/react";
import { Modal } from "antd";
import { useNavigate } from "react-router-dom";
import ConfirmationModal from "./ConfirmationModal";
import CreateMeetModal from "./CreateMeetModal";

interface RfxDetailModalsProps {
  // Meet — existing meeting confirm
  meetConfirm: boolean;
  onCloseMeetConfirm: () => void;
  currentMeet: string;
  // Meet — create new
  meetModal: boolean;
  onCloseMeetModal: () => void;
  meetResponder: any;
  // Submit warning
  submitWarningOpen: boolean;
  onCancelSubmit: () => void;
  loading: boolean;
  onConfirmSubmit: () => void;
  // Verify gate
  verifyGateOpen: boolean;
  onCloseVerifyGate: () => void;
  // Report RFX
  reportOpen: boolean;
  onCloseReport: () => void;
  reportReason: string;
  onReportReasonChange: (v: string) => void;
  reportLoading: boolean;
  onSubmitReport: () => void;
}

const RfxDetailModals: React.FC<RfxDetailModalsProps> = ({
  meetConfirm, onCloseMeetConfirm, currentMeet,
  meetModal, onCloseMeetModal, meetResponder,
  submitWarningOpen, onCancelSubmit, loading, onConfirmSubmit,
  verifyGateOpen, onCloseVerifyGate,
  reportOpen, onCloseReport, reportReason, onReportReasonChange, reportLoading, onSubmitReport,
}) => {
  const navigate = useNavigate();

  return (
    <>
      {/* Meet — existing meeting */}
      <Modal closeIcon={null} footer={null} title={null} open={meetConfirm}
        onOk={onCloseMeetConfirm} onCancel={onCloseMeetConfirm}>
        <ConfirmationModal
          handleCloseModal={onCloseMeetConfirm}
          handleSubmit={() => navigate("/seller/calendar?id=" + currentMeet)}
          title="Open meeting already exists"
          message="Please view & edit the same. View details now?"
          confirmBtnText="Yes, View"
          rejectButtonText="No"
        />
      </Modal>

      {/* Meet — create new */}
      <Modal closeIcon={null} footer={null} title={null} open={meetModal}
        onOk={onCloseMeetModal} onCancel={onCloseMeetModal}>
        <CreateMeetModal
          responderId={meetResponder?.userId}
          company={meetResponder?.buyerCompanyName}
          context="RFX"
          handleCloseModal={onCloseMeetModal}
        />
      </Modal>

      {/* Claude: submit warning — response is final 18-04-2026 */}
      <Modal open={submitWarningOpen} footer={null} closable={false} centered>
        <Box py={2}>
          <Text fontSize="sm" fontWeight={600} color="#0E122F" mb={3}>Submit Response?</Text>
          <Text fontSize="xs" color="gray.500" mb={5}>
            Once submitted, your response cannot be edited. The buyer will be able to see it.
          </Text>
          <Flex gap={3}>
            <Button flex={1} size="sm" bg="#0E122F" color="white" _hover={{ bg: "#1a1f45" }}
              isLoading={loading} onClick={onConfirmSubmit}>
              Submit
            </Button>
            <Button flex={1} size="sm" variant="outline" color="gray.600"
              isDisabled={loading} onClick={onCancelSubmit}>
              Cancel
            </Button>
          </Flex>
        </Box>
      </Modal>

      {/* Claude: verification gate 03-03-2026 */}
      <Modal open={verifyGateOpen} onCancel={onCloseVerifyGate} footer={null} title={null} closeIcon={null} centered>
        <Box py={2}>
          <Text fontSize="md" fontWeight={600} mb={2} color="#0E122F">Profile Verification Required</Text>
          <Text fontSize="sm" color="gray.600" mb={5}>
            Please complete your profile verification to use this feature.
          </Text>
          <Flex gap={2} justifyContent="flex-end">
            <Button size="sm" variant="ghost" onClick={onCloseVerifyGate}>Cancel</Button>
            <Button size="sm" bg="#0E122F" color="white" borderRadius="8px" _hover={{ bg: "#2E3560" }}
              onClick={() => { onCloseVerifyGate(); navigate("/seller/profile"); }}>
              Go to Profile
            </Button>
          </Flex>
        </Box>
      </Modal>

      {/* Claude: N22 — Report RFX 03-03-2026 */}
      <Modal open={reportOpen} onCancel={onCloseReport} footer={null} title={null} closeIcon={null} centered>
        <Box py={2}>
          <Text fontSize="md" fontWeight={600} mb={1} color="#0E122F">Report this RFX</Text>
          <Text fontSize="sm" color="gray.500" mb={4}>
            Let us know why this RFX violates platform guidelines. Our team will review it.
          </Text>
          <Input
            placeholder="Reason (required)"
            value={reportReason}
            onChange={(e) => onReportReasonChange(e.target.value)}
            fontSize="sm"
            focusBorderColor="#7C66FF"
            borderRadius="8px"
            mb={4}
          />
          <Flex gap={2} justifyContent="flex-end">
            <Button size="sm" variant="ghost" onClick={onCloseReport}>Cancel</Button>
            <Button size="sm" bg="#C62828" color="white" borderRadius="8px" _hover={{ bg: "#B71C1C" }}
              isLoading={reportLoading} isDisabled={!reportReason.trim()} onClick={onSubmitReport}>
              Submit Report
            </Button>
          </Flex>
        </Box>
      </Modal>
    </>
  );
};

export default RfxDetailModals;
